import {LIMITED_CONCURRENCY_PROJECTS, VERY_LIMITED_CONCURRENCY_PROJECTS} from 'common/report/constants';
import type {Dashboard} from 'common/report/dashboards/types';
import {
  DEFAULT_QUERY_CONCURRENCY,
  MIN_QUERY_CONCURRENCY,
  scaleQueryConcurrency,
} from 'common/util/query-concurrency-scaling';

const DEFAULT_BACKGROUND_QUERY_CONCURRENCY = Math.ceil(DEFAULT_QUERY_CONCURRENCY / 2);
const MIN_BACKGROUND_QUERY_CONCURRENCY = Math.ceil(MIN_QUERY_CONCURRENCY / 2);
const MAX_CARDS_TO_LOAD_IMMEDIATELY = 10;

export function isLimited(projectId: string | undefined): boolean {
  return projectId !== undefined && LIMITED_CONCURRENCY_PROJECTS.has(projectId);
}

export function isVeryLimited(projectId: string | undefined): boolean {
  return projectId !== undefined && VERY_LIMITED_CONCURRENCY_PROJECTS.has(projectId);
}

export function isNotLimited(projectId: string | undefined): boolean {
  return !isLimited(projectId) && !isVeryLimited(projectId);
}

export function getMaxCardsToLoadImmediately(projectId?: string): number {
  if (isVeryLimited(projectId) || isLimited(projectId)) return 1;
  return MAX_CARDS_TO_LOAD_IMMEDIATELY;
}

export function getMaxConcurrentQueries(projectId?: string, dashboard?: Dashboard): number {
  const numCards = dashboard?.cards?.length ?? 0;
  if (isVeryLimited(projectId)) return 2;
  if (isLimited(projectId)) return 5;
  return scaleQueryConcurrency(numCards);
}

export function getMaxConcurrentBackgroundPoolQueries(projectId?: string, dashboard?: Dashboard): number {
  const numCards = dashboard?.cards?.length ?? 0;
  if (isVeryLimited(projectId) || isLimited(projectId)) return 1;
  return Math.max(DEFAULT_BACKGROUND_QUERY_CONCURRENCY - Math.floor(numCards / 10), MIN_BACKGROUND_QUERY_CONCURRENCY);
}
